import React, { useEffect, useState, useContext } from 'react';
import './Home.css';
import Bodypart from '../Component/Home/Bodypart';
import Slider from '../Component/Home/Slider';
import TechnologyNews from '../Component/Home/TrendingTopics';
import InternationalNews from '../Component/Home/RecentBlogs';
import Feature from '../Component/Home/Feature';
import SubscribeBox from '../Component/Sidebar/Subscribe';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { HomeContext } from '../Context/HomeContext'; // 👈 import context
import AdBlockHorizontalMultiplex from '../Component/Ads/AdBlockHorizontalMultiplex';

export default function Home() {
  const { homeData, setHomeData } = useContext(HomeContext); // 👈 use context
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = 'Funfillia - Laugh, Play, and Explore Every Day';

    const fetchData = async () => {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Client-Domain':'www.funfillia.com',
        },
      };

      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/home', options);
        setHomeData(res.data); // 👈 store in context

        const rawMeta = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(rawMeta, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };

    if (!homeData) fetchData(); // 👈 only fetch if not already cached
    else {
      // already available, still update metaTags from existing context data
      const rawMeta = homeData?.metaTags || '';
      const doc = new DOMParser().parseFromString(rawMeta, 'text/html');
      const tags = Array.from(doc.head.children);
      setMetaTags(tags);
    }
  }, [homeData, setHomeData]);

  const getMetaContent = (attr, value) => { 
    const tag = metaTags.find(t => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return ( 
    <>
      <Helmet>
        <title>{getMetaContent('name', 'title') || 'Funfillia - Laugh, Play, and Explore Every Day'}</title>
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />

        {/* Open Graph */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />

        <link rel="canonical" href="https://www.funfillia.com" />
      </Helmet>

      <div>
        <div className='main1'></div>
        <Bodypart data={homeData?.todayTopBlogs || []} />
        <Slider data={homeData?.headerSliderBlogs || []} />
        <AdBlockHorizontalMultiplex />
        <TechnologyNews data={homeData?.trendingTopics || []} />
        <InternationalNews data={homeData?.recentBlogs || []} />
        <Feature data={homeData?.featuredBlogs || []} />
        <AdBlockHorizontalMultiplex />
        <SubscribeBox />
      </div>
    </>
  );
}
